import React, { useState, useReducer, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Moment from 'react-moment';
import Icon from '@mdi/react'
import { mdiTrainCarContainer } from '@mdi/js';
import { mdiListBoxOutline } from '@mdi/js';
import { mdiPaperclip } from '@mdi/js';
import client from '../feathers';
import useIntl from '../hooks/useIntl';
import TMDataTable from '../lib/Table/TMDataTable';
import useAuth from '../hooks/useAuth';
import RequestForReleaseButton from '../components/request-for-release/RequestForReleaseButton';

const useStyles = makeStyles((theme) => ({
  icon: {
    display: 'flex',
    justifyContent: 'flex-start'
  },
  ref: {
  	color: theme.palette.secondary.dark,
  	marginLeft: '28px'
  },
  topAlign: {
  	'& td': {
  		verticalAlign: 'top',
  	}
  }
}));

export default function RequestForReleaseOverview() {
	
	const [state, dispatch] = useReducer(reducer, initialState);
  const { translate } = useIntl();
  const classes = useStyles();
  const { user } = useAuth();

  const fetchRequestsForRelease = async () => {
		const result = await client.service('requests-for-release').find({ query: { organizationAddress: user.organizationAddress }});
	  dispatch({ payload: { requests: result.data } })
  };

  useEffect(() => {
    fetchRequestsForRelease();
  }, []);

	const columns = [
		'Reference',
		'Carrier',
		'BL number',
		{
      name: "Containers",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
          	value
          		.sort((a, b) => a.localeCompare(b))
							.map((c, index) => (<React.Fragment key={`c-${index}`}>{c}<br/></React.Fragment>))  
          )
        }
      }
    },
		{
      name: "Attachments",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
        	return (
          	value
          		.sort((a, b) => a.name.localeCompare(b.name))
          		.map((f, index) => {
								return (
									<React.Fragment key={`f-${index}`}>
										<span className={classes.icon}>
											<Icon path={mdiPaperclip} size={1}/>&nbsp;{f.name}
										</span>
										{ f.ref && <small className={classes.ref}>Ref: {f.ref}</small> }
									</React.Fragment>
								)
							})
          )
        }
      }
    },
		'Status',
		{
      name: "Date",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Moment format="ddd DD MMM YYYY HH:mm" date={value}/>
          )
        }
      }
    },
		{
      name: "Releases",
      options: { filter: true, download: false, display: false, viewColumns: false }
    }, 
	];

	const getData = () => {
		return state.requests.map(r => {
			return [
				r.reference,
				r.carrier.name,
				r.blNumber,
				r.containers,
				r.files,
				r.status,
				r.createdAt,
				// hidden fields for search & filter
				r.containersRaw
			]
		})
	}

	return (
		<TMDataTable
      title={'Your requests for releases'}
      columns={columns}
      data={getData()}
      setRowProps={() => ({className: classes.topAlign})}
      options={{
	      print: false,
	      download: false,
	      filter: false,
	      viewColumns: false,
	      customToolbar: () => <RequestForReleaseButton user={user} fetchRequestsForRelease={fetchRequestsForRelease}/>,
	      customSearch: (searchQuery, currentRow, columns) => {
        	let isFound = false;
        	currentRow.forEach(col => {
	          if (col.toString().indexOf(searchQuery) >= 0) {
	            isFound = true;
	          }
        	});
        	return isFound;
      	},
      }}
    />
	);
}

const initialState = {
  requests: [],
}

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'RESET':
      return { ...initialState }
    default:
      // = SET
      return { ...state, ...payload }
  }
}
